<template>
  <div class="forwardbody">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>

    <div class="forwardbox">
      <!--转发的编辑-->
      <div class="forwardtext"><textarea placeholder="说一说你的想法" v-model="textvalue"></textarea></div>

      <!--转发带图片-->
      <div class="forwardimg" v-if="fileList.length>0">
        <van-uploader v-model="fileList" multiple :max-count="1" />
      </div>
      <!--转发的内容-->
      <div>
        <div class="forwardcomment">
          <div class="forward-c-textbox">
            <span>{{msgData.name}}：</span>
            <pre>{{msgData.content}}</pre>
          </div>
          <div v-if="msgData.msg_type==1" class="forward-c-imgbox">
            <div class="forward-c-imgbox-view" v-if="msgData.thumb.length>0">

              <van-image width="6rem" height="6rem" fit="cover" :src="msgData.thumb" />

            </div>
          </div>
          <div v-if="msgData.msg_type==2" class="forward-c-videobox">
            <div class="forward-c-videobox-view">
              <!-- <video src="{{msgData.content_extra}}"></video> -->
              <video :src="msgData.extra" show-fullscreen-btn="true" style="z-index:1" controls="controls" preload="auto"></video>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="forwardhfbox">
      <div class="forwardh-btn">
        <button @click="updatasubmit" :disabled="isDisable" class="cu-btn bg-green shadow-blur cu-btn-fsbtn">发送</button>
      </div>
      <div class="forwardh-img" v-if="fileList.length==0">
        <van-uploader v-model="fileList" multiple :max-count="1"><img :src="dynamicnormal" /></van-uploader>
      </div>
      <div class="forwardh-img" v-else>
        <img :src="dynamicdisable" />
      </div>
    </div>

  </div>
</template>

<script>
import { getforward, getpubishcircle } from "../../api/api";
import navbar from "../public/navbar.vue";
import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";
import { mapState } from 'vuex';

// 全局注册
Vue.use(Toast);

export default {
  name: "forward",
  components: { navbar },
  data () {
    return {
      isDisable: false,
      titlename: "转发动态",
      textvalue: "",
      msgData: {},
      is_own: "",
      isdynamic: "",
      fileList: [],
      dynamicnormal: require("../../assets/images/dynamic_btn_pic_normal.png"),
      dynamicdisable: require("../../assets/images/dynamic_btn_pic_disable.png"),
      showchooseicon: true,
      imgList: ""
    };
  },
  created () {
    document.title = '转发';
    let isdynamic = false;
    let is_own;
    let isartcle = null;

    isdynamic = this.$route.query.isdynamic;
    is_own = this.$route.query.is_own;
    let msg_id = this.$route.query.msg_id;

    getforward(msg_id).then(res => {
      if (res.data.code == 200) {
        this.msgData = res.data.data;
        (isdynamic = isdynamic), (is_own = is_own);
      } else {
        wx.showToast({
          title: "转发失败!",
          icon: "none"
        });
      }
    }).catch(err => {
    });
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  methods: {
    updatasubmit () {
      this.isDisable = true
      let that = this;

      let content = this.textvalue;

      if (content.length == 0) {
        content = "转发动态";
      }


      let like_id = 0;
      let pid = this.msgData.msg_id;
      let extra;


      // 对图片进行压缩
      function compress (img) {
        //新建一个img标签
        var image = new Image();
        image.src = img;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        //压缩后图片的大小
        var data;
        if (image.width > 800 || image.height > 1200) {
          var imageWidth = image.width * 0.38;
          var imageHeight = image.height * 0.38;
        } else if (image.width < 800 && image.width > 500 || image.height > 1000) {
          var imageWidth = image.width * 0.6;
          var imageHeight = image.height * 0.6;
        } else if (image.width <= 500 && image.width > 200 || image.height > 800) {
          var imageWidth = image.width * 0.8;
          var imageHeight = image.height * 0.8;
        } else {
          var imageWidth = image.width * 1;
          var imageHeight = image.height * 1;
        }
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        context.drawImage(image, 0, 0, imageWidth, imageHeight);
        data = canvas.toDataURL('image/jpeg');
        var length = data.toString().length;
        if (length > 1024 * 200) {
          return compress(data);
        }
        return data;
      }



      if (this.fileList.length > 0) {

        var base64String = compress(this.fileList[0].content);
        //这里对base64串进行操作，去掉url头，并转换为byte
        var bytes = window.atob(base64String.split(",")[1]);

        //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var j = 0; j < bytes.length; j++) {
          ia[j] = bytes.charCodeAt(j); //这里有点疑惑，ia是怎么改变ab的？注：①
        }
        //Blob对象
        var blob = new Blob([ab], { type: "image/jpeg" }); //type为图片的格式
        //FormData对象
        var formData = new FormData();

        formData.append("file", blob, Date.now() + ".jpg");
        axios.defaults.headers.common["PLATFORM"] = "H5";
        //上传
        const instance = axios.create({
          withCredentials: false
        });



        const baseURL = this.baseAPI;

        instance
          .post(baseURL + "/file-bases/images", formData)
          .then(res => {
            if (res.data.code == 200) {
              let extra = res.data.data.url;
              uptijiao(extra)

            }
          })
          .catch(function (error) {
            console.log(error);
          });

      } else {
        let extra;
        uptijiao(extra)


      }

      function uptijiao (extra) {

        getpubishcircle(content, 1, like_id, extra, pid).then(res => {
          that.isDisable = false
          if (res.code == 200) {

            that.$router.go(-1);

          } else {

            Toast.fail("发布失败,请重试！");

          }
        }).catch(function (error) {
          that.isDisable = false
          Toast.fail("发布失败,请重试！");
        });

      }



    }
  }
};
</script>

<style>
.forwardbody {
  height: 100%;
  background: #fff;
}
.forwardbox {
  padding-top: 50px;
}
.forwardimg {
  padding-left: 0.7rem;
  padding-bottom: 0.8rem;
}
.forwardimg .van-image {
  width: 6.162162162162162rem;
  height: 6.162162162162162rem;
}

.forwardbox .forwardtext {
  padding-left: 0.6486486486486487rem;
  padding-right: 0.6486486486486487rem;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.6rem;
}
.forwardbox .forwardtext textarea {
  width: 100%;
  border: none;
  height: 6.756756756756757rem;
  font-size: 0.8108108108108109rem;
}

.forwardbox .forwardcomment {
  background: #f6f6f6;
  margin: 0 0.6756756756756757rem;
  padding: 0.8108108108108109rem;
}
.forwardbox .forwardcomment .forward-c-textbox {
  font-size: 0.7567567567567568rem;
  line-height: 1.2432432432432432rem;
  color: #333;
}
.forwardbox .forwardcomment .forward-c-textbox span {
  font-weight: bold;
  padding-right: 0.13513513513513514rem;
}
.forwardbox .forwardcomment .forward-c-imgbox {
}
.forwardbox .forwardcomment .forward-c-imgbox .forward-c-imgbox-view {
  padding-top: 0.5405405405405406rem;
}
.forwardbox .forwardcomment .forward-c-imgbox .forward-c-imgbox-view img {
  width: 5.945945945945946rem;
  height: 5.945945945945946rem;
  background: #eee;
}
.forwardbox .forwardcomment .forward-c-videobox {
}
.forwardbox .forwardcomment .forward-c-videobox .forward-c-videobox-view {
  padding-top: 0.5405405405405406rem;
}
.forwardbox .forwardcomment .forward-c-videobox .forward-c-videobox-view video {
  width: 100%;
  height: 8.108108108108109rem;
  background: rgba(0, 0, 0, 0.5);
}

.forwardhfbox {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}
.forwardhfbox .forwardh-img {
  padding-top: 0.40540540540540543rem;
  padding-left: 0.8108108108108109rem;
}
.forwardhfbox .forwardh-img img {
  width: 1.3513513513513513rem;
  height: 1.0810810810810811rem;
}
.forwardhfbox .forwardh-btn {
  float: right;
  padding-right: 0.8rem;
  padding-bottom: 0.7027027027027027rem;
}
.forwardhfbox .forwardh-btn .cu-btn-fsbtn {
  width: 3.135135135135135rem;
  height: 1.7297297297297298rem;
  border-radius: 1.0810810810810811rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  border: none;
  font-size: 0.75rem;
  color: #fff;
  box-shadow: 0 0 3px rgb(255, 189, 10);
}
pre {
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/forward.vue